import { DefaultFooter } from '@ant-design/pro-components';
import React from 'react';

const Footer: React.FC = () => {
  return (
    <DefaultFooter
      style={{ background: 'none' }}
      copyright={`${new Date().getFullYear()} 鼎旻 DingMin ERP`}
      links={[
        {
          key: 'beian',
          title: '冀ICP备2026016054号',
          href: 'http://beian.miit.gov.cn/',
          blankTarget: true,
        },
        {
          key: 'mps-beian',
          title: '冀公网安备13010802002769号',
          href: 'https://beian.mps.gov.cn/#/query/webSearch?code=13010802002769',
          blankTarget: true,
        },
      ]}
    />
  );
};

export default Footer;
